import React, { Component } from 'react';
import './favoritos.css';
import Sdk from 'api.digitalpages.module.sdk.api';
import { UsersService } from '../../services/user';
import AuthorService from '../../services/AuthorService';

import {
  HeaderShelf,
  SidebarRoundedIcons,
  Footer,
  Preloader
} from '../../components';

const CACHE_KEY = 'view_favoritos_cache';

export default class ViewFavoritos extends Component {
  constructor(props) {
    super(props);

    const cached = this.loadFromCache();
    this.state = {
      loading: !cached,
      favorites: cached?.favorites || [],
      authors: cached?.authors || []
    };
    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;
    this.loadFavorites();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  loadFromCache() {
    try {
      const raw = localStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }

  saveToCache(data) {
    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify(data));
    } catch {
      // localStorage cheio ou indisponível
    }
  }

  isEqual(a, b) {
    return JSON.stringify(a) === JSON.stringify(b);
  }

  loadFavorites = async () => {
    try {
      const [authors, userData] = await Promise.all([
        AuthorService.loadAuthors(),
        this.getUserDataWithFavorites()
      ]);
      
      const contentsUids = [...new Map(
        userData.map(p => [p.contextUid, p.contextUid])
      ).values()];
      
      const favoriteContents = await Promise.all(
        contentsUids.map(uid => this.getContentDetail(uid, authors))
      );
      
      const freshData = {
        favorites: favoriteContents.filter(content => content),
        authors
      };
      const cached = this.loadFromCache();

      if (this._isMounted) {
        if (!cached || !this.isEqual(cached, freshData)) {
          this.saveToCache(freshData);
          this.setState({ ...freshData, loading: false });
        } else {
          this.setState({ loading: false });
        }
      }
    } catch (error) {
      console.error('Error loading favorites:', error);
      if (this._isMounted) {
        this.setState({ loading: false });
      }
    }
  }

  getUserDataWithFavorites = async () => {
    const result = [];
    let page = 1;
    
    while (true) {
      const url = `cms/v1.1/user/data?page=${page}`;
      const response = await Sdk.Api.dynamic.bridge(url, null, "GET");
      
      const favoriteData = response.result.filter(p => 
        p.tags && 
        p.tags.length > 0 && 
        p.target_type === "ManagedContent" && 
        p.context_type === "ManagedContent" && 
        p.tags.find(t => t.name === "###InternalFavorites###") != null
      );
      
      result.push(...favoriteData.map(this.toUserData));
      
      if (!response.next_page_query) break;
      page++;
    }
    
    return result;
  }

  getContentDetail = async (contentUid, authors) => {
    try {
      const url = `cms/v1.1/managed/content/group/uid/${contentUid}`;
      const response = await Sdk.Api.dynamic.bridge(url, null, "GET");
      return this.toContent(response, authors);
    } catch (error) {
      console.error('Error loading content:', contentUid, error);
      return null;
    }
  }

  toUserData = (serverData) => ({
    uid: serverData.uid,
    contextType: serverData.context_type,
    contextUid: serverData.context_uid,
    targetType: serverData.target_type,
    targetUid: serverData.target_uid,
    tags: serverData.tags?.map(t => ({ uid: t.uid, name: t.name }))
  })

  toContent = (serverData, authors) => {
    let author = serverData.properties?.find(p => 
      p.name === "Autor" || 
      p.name === "autor" || 
      p.name === "Author" || 
      p.name === "AUTOR"
    )?.value;

    if (!author && serverData.entities && authors.length) {
      author = AuthorService.updateContentAuthor(serverData, authors);
    }

    if (!author || author === 'Autor não disponível') {
      author = serverData.author || 
        serverData.properties?.find(p => p.name.toLowerCase().includes('autor'))?.value || 
        'Autor não informado';
    }

    return {
      uid: serverData.uid,
      title: serverData.name || 'Título não disponível',
      author: author,
      description: serverData.properties?.find(p => p.name === "Descrição")?.value,
      image: this.getImageUrl(serverData.uid)
    };
  }

  onBookClick = (book) => {
    // Navigate to book detail or player
    window.location.hash = `#/content/uid/${book.uid}/detail`;
  }

  getImageUrl(uid) {
    var url = `${Sdk.Api.domain}/cms/v1.1/managed/content/group/uid/${uid}/default/thumb/v2?image_options=width:200&api_env=${Sdk.Api.enviroment}&project_key=${Sdk.Api.projectKey}&access_token=${Sdk.Api.authorization.credential.accessToken}`;

    return url;
  }

  async signOut() {
    await UsersService.signOut()
    window.location = window.location.origin + window.location.pathname + "#/login";
  }

  render() {
    const { loading, favorites } = this.state;
    
    if (loading) {
      return (
        <Preloader/>
        // <div className="rdp-react-template-view-favoritos">
        //   <div className="rdp-react-template-view-favoritos-loading">
        //     <div className="rdp-react-template-view-favoritos-loader"></div>
        //   </div>
        // </div>
      );
    }

    return (
      <div className="rdp-react-template-view-favoritos">
        <div className="rdp-react-template-view-favoritos-header">
          <HeaderShelf
            onSignOut={() => this.signOut()}
            renderSearch={false}
          />
        </div>

        <div className="rdp-react-template-view-favoritos-sidebar">
          <SidebarRoundedIcons />
        </div>

        <div className="rdp-react-template-view-favoritos-main">
          <div className="rdp-react-template-view-favoritos-container">
            <div className="rdp-react-template-view-favoritos-header-section">
              <h1 className="rdp-react-template-view-favoritos-title">Favoritos</h1>
            </div>

            <div className="rdp-react-template-view-favoritos-content">
              {favorites.length === 0 ? (
                <div className="rdp-react-template-view-favoritos-empty">
                  <p>Você ainda não possui livros selecionados como <strong>Favoritos</strong></p>
                </div>
              ) : (
                <div className="rdp-react-template-view-favoritos-items">
                  {favorites.map((book, index) => (
                    <div 
                      key={book.uid || index} 
                      className="rdp-react-template-view-favoritos-item"
                      onClick={() => this.onBookClick(book)}
                    >
                      <img 
                        className="rdp-react-template-view-favoritos-item-cover blur" 
                        src={book.image} 
                        alt={book.title}
                        loading="lazy"
                        onLoad={(e) => e.target.classList.add('loaded')}
                      />
                      <div className="rdp-react-template-view-favoritos-item-title">
                        {book.title}
                      </div>
                      <div className="rdp-react-template-view-favoritos-item-title" style={{marginTop: '10px', fontWeight: '1000', fontSize: '10px', height: "28px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"}}>
                        {book.author}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
          <Footer/>
        </div>
      </div>
    );
  }
}